<app-dialog i18n-headerText="XTIT|Creation finished YAML download header text@@organizations.unified-creation-finished-yaml-confirmation-dialog.headerText"
            headerText="Download Test YAML Files" [body]="body" [showCancelButton]="true"
            [showSaveButton]="false" cancelText="Close" (cancel)="onClose()" [showTopCancelButton]="false"></app-dialog>

<ng-template #body>
    <div i18n="XMSG|Creation finished YAML download message@@organizations.unified-creation-finished-yaml-confirmation-dialog.bodyText">
        We noticed that you didn't download the YAML files to help with your testing of the provisioning flow for your app. <br/><br/>
        These YAML files won't be available after you close this confirmation.

        <fd-checkbox
                i18n-label="XMSG|Creation finished YAML checkbox message@@organizations.unified-creation-finished-yaml-confirmation-dialog.checkboxMessage"
                label="Download YAML test files"
                title="Downloads the YAML test files after you click Close"
                [(ngModel)]="isDownloadSelected"
                [fdCompact]="true"
        ></fd-checkbox>
    </div>
</ng-template>

